<template>
    <div v-show="isActive" role="tabpanel" :aria-labelledby="name"><slot></slot></div>
</template>

<script>
export default {
    props: {
        name: { required: true },
        selected: { default: false }
    },
    data() {
        return {
            isActive: false
        };
    },
    computed: {
        href() {
            return '#' + this.name.replace(/[\s\/\,\&]/g, '-');
        }
    },
    mounted() {
        this.isActive = this.selected;
    },
};
</script>
